import type { DashboardStats } from '@maker-toolchest/shared';
import { api } from '@/lib/api';

/**
 * Stats API client
 */
export const statsApi = {
  /**
   * Get dashboard statistics
   */
  async getDashboardStats(): Promise<DashboardStats> {
    const response = await api.get<DashboardStats>('/stats/dashboard');
    if (!response.data) {
      throw new Error('No data returned from stats endpoint');
    }
    return response.data;
  },
};
